import { useQuery } from "react-query";
import { getOnlineDirectoriesConfig } from "../../../../../actions/Utilities/OnlineDirectories";
export default function useGetOnlineDirectories() {
  return useQuery("GetOnlineDirectories", getOnlineDirectoriesConfig, {
    refetchOnWindowFocus: false,
  });
}
